import type { AxiosInstance } from 'axios';
import type {
  PlotWaypointListResponse,
  ListQueryParams,
  EntityId,
} from '@/types';

export const getPlotWaypoints = async (
  api: AxiosInstance,
  plot_id: EntityId,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<PlotWaypointListResponse> => {
  const resp = await api.get<PlotWaypointListResponse>(`/plot/${plot_id}/waypoint`, {
    params: { limit, start_key, name } as ListQueryParams,
  });
  return resp.data;
};

